import React from 'react';
import { StyledMenu, StyledMenuButton, StyledMenuItem } from 'components/atoms/Menu/Menu/Menu.styles';

export function MenuItem({ children, icon, ...props }) {
  return (
    <StyledMenuItem onSelect={() => {}} {...props}>
      {icon ?? null}
      {children}
    </StyledMenuItem>
  );
}

function MenuButton({ children, icon,text, button, top,...props }) {
  return (
    <StyledMenu $top={top} menuButton={<StyledMenuButton button={button}>{text}{icon}</StyledMenuButton>} {...props}>
      {children}
    </StyledMenu>
  );
}

export default MenuButton;
